import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DettaglioLinee } from 'src/app/entities/invoices';
import { ConfigProps, ConfigServiceService } from 'src/app/services/config-service/config-service.service';


@Component({
  selector: 'app-info-dettaglio-linee',
  templateUrl: './info-dettaglio-linee.component.html',
  styleUrls: ['./info-dettaglio-linee.component.css']
})
export class InfoDettaglioLineeComponent implements OnInit {

  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  @Input() dL: DettaglioLinee | undefined;
  
  public configTabs = {
    selected: 1,
    config: [
      {
        id: 1, 
        name: "invoices.edit.serviceData.other.tabs.tab1_M1"
      },
      {
        id: 2,
        name: "invoices.edit.serviceData.other.tabs.tab2_M1"
      }
    ]
  }

  config : ConfigProps | undefined;

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal, private configService: ConfigServiceService) {
    this.innerWidth = window.innerWidth;
  }

  async ngOnInit() {
    this.config = await this.configService.getJSON();
  }


  public addCodiceArticolo(){
    this.dL!.CodiceArticolo.push({CodiceTipo: '', CodiceValore: ''});
  }
  public deleteCodiceArticolo(doc:  { CodiceTipo: string; CodiceValore: string; }){
    this.dL!.CodiceArticolo.splice(this.dL!.CodiceArticolo.indexOf(doc), 1);
  }
  
  public checkRitenuta(event: any){
    this.dL!.Ritenuta = event.target.checked ? 'SI' : '';
  }

  public addScontoMaggiorazione(){
    this.dL!.ScontoMaggiorazione.push({Tipo: 'SC', Importo: '',Percentuale: ''});
  }

  public deleteScontoMaggiorazione(index: number){
    this.dL?.ScontoMaggiorazione.splice(index, 1);
  }

  public addDatiGestionali(){
    this.dL!.AltriDatiGestionali.push({RiferimentoData:'', RiferimentoNumero: '',RiferimentoTesto:'',TipoDato:''});
  }

  public deleteDatiGestionali(index: number){
    this.dL!.AltriDatiGestionali.splice(index, 1);
  }

  public  getTotImporto(){
    let prezzoUnitario : number = +this.dL!.PrezzoUnitario;
    this.dL!.ScontoMaggiorazione.forEach(i => {
      if(i.Importo != '' || i.Percentuale != ''){
        switch(i.Tipo){
          case "SC":
            if(i.Importo == '' || +i.Importo == 0){
              // Pecerntuale sconto
              prezzoUnitario = prezzoUnitario - ((prezzoUnitario / 100) * parseFloat("" + i.Percentuale));
            } else {
              // Importo sconto
              prezzoUnitario = prezzoUnitario - parseFloat(i.Importo);
            }
            break;
          case "MG":
            if(i.Importo == '' || +i.Importo == 0){
              // Pecerntuale sconto
              prezzoUnitario = prezzoUnitario + ((prezzoUnitario / 100) * parseFloat("" + i.Percentuale));
            } else {
              // Importo sconto
              prezzoUnitario = prezzoUnitario + parseFloat(i.Importo);
            }
            break;
        }
      }
    });
    this.dL!.PrezzoTotale = parseFloat("" + (+this.dL!.Quantita * prezzoUnitario).toFixed(2));
  }

  close(){
    this.activeModal.close(null);
  }

  public save(){
    //convalido prima le linee
    if(this.dL?.ScontoMaggiorazione!=undefined){
        let count=this.dL.ScontoMaggiorazione.length-1;
        for(var i=count;i>=0;i--){
          if(this.dL.ScontoMaggiorazione[i].Importo=='' && this.dL.ScontoMaggiorazione[i].Percentuale=='')
            this.dL.ScontoMaggiorazione.splice(i,1);
        }
      }
    //convalido altri dti gestionali
    if(this.dL?.AltriDatiGestionali!=undefined){
      let count=this.dL.AltriDatiGestionali.length-1;
      for(var i=count;i>=0;i--){
        if(this.dL.AltriDatiGestionali[i].TipoDato=='')
          this.dL.AltriDatiGestionali.splice(i,1);
      }
    }
    this.activeModal.close(this.dL!);
  }


}
